import React from 'react';
import { useLocation, Link } from "react-router-dom";
import { useLanguage } from '../contexts/LanguageContext'; // Import the language context
import MainLayout from '../components/Layouts/MainLayout';
import BannerImg from '../assets/main-banner.png';
// import TestimonialSlider from '../components/PagesComponents/TestimonialSlider';
import TestimonialSlider from '../components/PagesComponents/Testimonials';
import WhatWeOffers from '../components/PagesComponents/WhatWeOffers';
import ImageSlider from '../components/PagesComponents/ImageSlider';
import WhyChoose from '../components/PagesComponents/WhyChoose';
import Contact from '../components/PagesComponents/Contact';
import Services from '../components/PagesComponents/Services'
import { translations } from "../i18n"; // Import translations

const ORANGE = "#f7941d";

const styles = {
  ctaBtn: {
    background: ORANGE,
    color: "#fff",
    border: "none",
    borderRadius: 6,
    padding: "12px 36px",
    fontWeight: 700,
    fontSize: "1rem",
    cursor: "pointer",
    textTransform: "uppercase",
    letterSpacing: 1,
  }
}

const Home = () => {
  const { language } = useLanguage(); // Get current language
  const homeData = translations[language]?.home; // Fetch homepage content based on language

  if (!homeData) {
    return <p>Loading...</p>; // Fallback in case content isn't loaded
  }

  return (
    <MainLayout>
      {/* Hero Banner */}
      <ImageSlider/>
      {/* <section className='hero-banner'>
        <div className='container-fluid'>
          <div className='row align-items-center'>
            <div className='col-lg-6 py-4'>
              <div className="p-3">
                <h5 className="text-white text-uppercase mb-3 animated slideInDown">{homeData.welcome}</h5>
                <h1 className="display-4 text-white mb-md-4 animated zoomIn">{homeData.heroTitle}</h1>
                <p className="text-white mb-md-4">{homeData.heroDescription}</p>
              </div>
            </div>
            <div className='col-lg-6'>
              <img src={BannerImg} alt='Hero Banner' />
            </div>
          </div>
        </div>
      </section> */}

      {/* What We Offer Section */}
      {/* <WhatWeOffers /> */}

      <Services />

      {/* Why Choose Us Section */}
      <WhyChoose/>
      {/* <section className="why-choose">
      <div className="why-choose__container">
        <div className="what-we-offer-section__header">
          <h2 className="what-we-offer-section__title">{homeData.whyChooseTitle}</h2>
          <div className="what-we-offer-section__title-decoration">
            <div className="what-we-offer-section__decoration-line"></div>
            <div className="what-we-offer-section__decoration-dot"></div>
            <div className="what-we-offer-section__decoration-line"></div>
          </div>
        </div>

        <div className="why-choose__grid">
          {homeData.whyChooseUs.map((item, index) => (
            <div 
              key={index} 
              className="why-choose__card"
              data-aos="fade-up" 
              data-aos-delay={index * 100}
            >
              <div className="why-choose__card-inner">
                <div className="why-choose__card-number">0{index + 1}</div>
                <h3 className="why-choose__card-title">{item}</h3>
                <div className="why-choose__card-hover"></div>
              </div>
              <div className="why-choose__card-glow"></div>
            </div>
          ))}
        </div>
      </div>
    </section> */}
    <Contact />

      {/* Get Started Section */}
      <div className='container my-5 container-card-cta'>
      <section className="cta-section">
      <div className="cta-container">
        <div className="cta-content">
          <h2 className="cta-title">
            <span className="cta-title-gradient">{homeData.getStartedTitle}</span>
          </h2>
          
          <div className="cta-text-wrapper">
            <p className="cta-description">
              {homeData.getStartedDescription.split(homeData.registerLinkText)[0]}
              {/* <Link to="/register" className="cta-link">
                <span className="cta-link-text">{homeData.registerLinkText}</span>
                <span className="cta-link-icon">→</span>
              </Link> */}
              <Link to="/register">
                <button style={styles.ctaBtn}>
                  Register Today
                </button>
              </Link>
              {homeData.getStartedDescription.split(homeData.registerLinkText)[1]}
            </p>
          </div>

          <div className="cta-decoration">
            <div className="cta-decoration-circle cta-decoration-circle--large"></div>
            <div className="cta-decoration-circle cta-decoration-circle--medium"></div>
            <div className="cta-decoration-circle cta-decoration-circle--small"></div>
          </div>
        </div>
      </div>
    </section>
    </div>

      {/* Testimonial Slider */}
      {/* <TestimonialSlider /> */}
    </MainLayout>
  );
};

export default Home;